import profileMessages from '@rhg/lang/messages/profile';
import { IntlShape } from 'react-intl';

/**
 * Sponsor/partner welcome-logo accessible name, built client-side from
 * `partnerDisplayName` — deliberately never from the backend-owned
 * `welcomeLogo`/`welcomeSquareLogo`.altText, which is sometimes
 * insufficiently descriptive (e.g. "Offered through Calm Demo").
 */
export const getSponsorLogoAlt = (
    formatMessage: IntlShape['formatMessage'],
    partnerName: string
) =>
    partnerName
        ? formatMessage(profileMessages['profile.sponsor_logo_alt'], {
              partnerName,
          })
        : undefined;
